import {accountMovement} from "./zh/accountMovement";
import {balanceBonus} from "./zh/balanceBonus";
import {bankDeposit} from "./zh/bankDeposit";
import {baseModalTitles} from "./zh/baseModalTitles";
import {breadcrumbs} from "./zh/breadcrumbs";
import {changePassword} from "./zh/changePassword";
// import accounts from "./zh/accounts";
import {contact} from "./zh/contact";
import {cookieConsent} from "./zh/cookieConsent";
import {currency} from "./zh/currency";
import {deleteAccount} from "./zh/deleteAccount";
import {dropdownMenu} from "./zh/dropdownMenu";
import {errorBoundary} from "./zh/errorBoundary";
import {floatBtn} from "./zh/floatBtn";
import {floatingMenu} from "./zh/floatingMenu";
import {footer} from "./zh/footer";
import {gameFeed} from "./zh/gameFeed";
import {games} from "./zh/games";
import {homeBtnMoneyHandler} from "./zh/homeBtnMoneyHandler";
import {homeDisplayTitles} from "./zh/homeDisplayTitles";
import {homeModalSessionInfo} from "./zh/homeModalSessionInfo";
import {identity} from "./zh/identity";
import {inviteFriend} from "./zh/inviteFriend";
import {loginModal} from "./zh/loginModal";
import {lottery} from "./zh/lottery";
import {mobilePayment} from "./zh/mobilePayment";
import {news} from "./zh/news";
import {notificationDrawer} from "./zh/notificationDrawer";
import {notifications} from "./zh/notifications";
import {promoBanners} from "./zh/promoBanners";
import {quiniela} from "./zh/quiniela";
import {raffle} from "./zh/raffle";
import {referral} from "./zh/referral";
import {registrationForm} from "./zh/registrationForm";
import {sideNavbar} from "./zh/sideNavbar";
import {socialNotifications} from "./zh/socialNotifications";
import {socialSelector} from "./zh/socialSelector";
import {contactSupport} from "./zh/support";
import {TOS} from "./zh/TOS";
import {testimonials} from "./zh/testimonials";
import {transactionTitles} from "./zh/transactionTitles";
import {transferSteps} from "./zh/transferSteps";
import {userProfile} from "./zh/userProfile";
import {wallet} from "./zh/wallet";
import {withdrawalSteps} from "./zh/widthdrawalSteps";

const zh = {
  // ...accounts,
  ...contact,
  ...cookieConsent,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...identity,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...homeDisplayTitles,
  ...lottery,
  ...raffle,
  ...balanceBonus,
  ...loginModal,
  ...errorBoundary,
  ...homeModalSessionInfo,
  ...games,
  ...gameFeed,
  ...breadcrumbs,
  ...floatingMenu,
  ...referral,
  ...socialSelector,
  ...promoBanners,
  ...socialNotifications,
  ...testimonials,
  ...news,
  latestWinners: "最新赢家",
  noDataAvailable: "没有可用数据",
  homeModalSessionInfoAtTime: "于",
  yourReferralLink: "你的链接",
  qrCode: "二维码",
  categoryUnavailableTag: "即将上线",
  categoryUnavailableTitle: "我们正在改进该分类的体验",
  categoryUnavailableTitleNamed: "我们正在改进 {{category}} 的体验",
  categoryUnavailableMessage: "该页面即将重新开放。我们正在为您提供更好的体验，感谢您的耐心。",
  categoryUnavailableBack: "返回首页",
  categoryUnavailableExplore: "探索其他游戏",
  ...quiniela,
};

export default zh;
